import { render, staticRenderFns } from "./CampaignModal.vue?vue&type=template&id=3a006f16"
import script from "./CampaignModal.vue?vue&type=script&lang=js"
export * from "./CampaignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a006f16')) {
      api.createRecord('3a006f16', component.options)
    } else {
      api.reload('3a006f16', component.options)
    }
    module.hot.accept("./CampaignModal.vue?vue&type=template&id=3a006f16", function () {
      api.rerender('3a006f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/globalModals/CampaignModal.vue"
export default component.exports